export default __webpack_public_path__ + "static/media/intel-new.aaac2611.gif";